import React, { useCallback, useState } from 'react';
import Analytics from 'react-ga';
import { makeStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import intl from 'react-intl-universal';
import AppInfo from './AppInfo';
import ContactForm from '../ContactForm';
import RedirectWidget from './RedirectWidget';
import SignUpStepper from '../SignUpStepper';
import Welcome from './Welcome';

const useStyles = makeStyles(theme => ({
  rootContainer: {
    display: 'flex',
    justifyContent: 'center',
    '@media (max-width: 50rem)': {
      alignItems: 'center',
      flexDirection: 'column',
      marginTop: 0
    }
  },
  leftContainer: {
    flex: 1,
    marginRight: theme.spacing(4),
    '@media (max-width: 50rem)': {
      marginRight: theme.spacing(0)
    }
  },
  rightContainer: {
    maxWidth: '446px',
    marginLeft: theme.spacing(4),
    '@media (max-width: 50rem)': {
      marginLeft: theme.spacing(0)
    }
  },
  box: {
    boxShadow: '0 12px 12px -3px #ccc'
  },
  stepper: {
    padding: 0
  },
  step: {
    display: 'none'
  }
}));

export default function SignUpSection() {
  const classes = useStyles();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const onSignUpSuccess = useCallback(
    (email: string, password: string) => {
      setEmail(email);
      setPassword(password);
      setStep(2);
      Analytics.event({
        action: 'register click',
        category: 'freemium register'
      });
    },
    [setEmail, setPassword, setStep]
  );
  return (
    <section>
      <Box className={classes.rootContainer} mt={4} mx={4}>
        <Box className={classes.leftContainer} my={2}>
          {step === 1 && <AppInfo />}
          {step === 2 && <Welcome />}
        </Box>
        <Box className={classes.rightContainer} my={2}>
          <SignUpStepper step={step} totalSteps={2} />
          <Box className={classes.box} p={4}>
            {step === 1 && (
              <ContactForm onSignUpSuccess={onSignUpSuccess} buttonText={intl.get('components.ContactForm.register')} />
            )}
            {step === 2 && <RedirectWidget email={email} password={password} />}
          </Box>
        </Box>
      </Box>
    </section>
  );
}
